"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Typography: true,
  SingleLineCssTrim: true,
  createGlobalFont: true,
  generateMaterialIconsFontFaces: true,
  Fonts: true,
  FontFamily: true,
  FontWeight: true,
  MaterialIconFontFace: true,
  MaterialIconsType: true
};
Object.defineProperty(exports, "FontFamily", {
  enumerable: true,
  get: function get() {
    return _typography.FontFamily;
  }
});
Object.defineProperty(exports, "FontWeight", {
  enumerable: true,
  get: function get() {
    return _typography.FontWeight;
  }
});
Object.defineProperty(exports, "Fonts", {
  enumerable: true,
  get: function get() {
    return _typography.Fonts;
  }
});
Object.defineProperty(exports, "MaterialIconFontFace", {
  enumerable: true,
  get: function get() {
    return _typography.MaterialIconFontFace;
  }
});
Object.defineProperty(exports, "MaterialIconsType", {
  enumerable: true,
  get: function get() {
    return _typography.MaterialIconsType;
  }
});
exports.Typography = exports.SingleLineCssTrim = void 0;
Object.defineProperty(exports, "createGlobalFont", {
  enumerable: true,
  get: function get() {
    return _createGlobalFont.createGlobalFont;
  }
});
Object.defineProperty(exports, "generateMaterialIconsFontFaces", {
  enumerable: true,
  get: function get() {
    return _generateMaterialIconsFontFaces.generateMaterialIconsFontFaces;
  }
});
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledSystem = require("styled-system");
var _cursor = require("../Utilities/cursor");
var _createGlobalFont = require("./createGlobalFont");
var _generateMaterialIconsFontFaces = require("./generateMaterialIconsFontFaces");
var _textDecoration = require("./textDecoration");
Object.keys(_textDecoration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _textDecoration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _textDecoration[key];
    }
  });
});
var _textOverflow = require("./textOverflow");
var _textTransform = require("./textTransform");
var _typography = require("./typography.types");
var _whiteSpace = require("./whiteSpace");
var _wordSpacing = require("./wordSpacing");
var _templateObject, _templateObject2;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Typography = _styledComponents["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"])), _styledSystem.typography, _styledSystem.textStyle, _styledSystem.space, _textDecoration.textDecoration, _wordSpacing.wordSpacing, _cursor.cursor, _styledSystem.color, _textTransform.textTransform, _styledSystem.layout, _textOverflow.textOverflow, _whiteSpace.whiteSpace);
exports.Typography = Typography;
var SingleLineCssTrim = (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
exports.SingleLineCssTrim = SingleLineCssTrim;